import axios from "axios";
import { API_BASE_URL } from "./baseUrl";
import { shouldRedirectToLogin } from "./authRedirect";

/**
 * API
 * ---
 * Single axios instance for all backend calls.
 *
 * Request interceptor:
 * - Attaches the JWT from localStorage as a Bearer token.
 * - Honors an explicitly-set `Authorization` header (used by the reset/init
 *   password flow, where the token is one-shot from the URL — not localStorage).
 *
 * Response interceptor:
 * - Redirects to /login on 401, except for endpoints in NO_REDIRECT_ON_401
 *   (see authRedirect.ts).
 */

// Mirrors AuthenticationService.TOKEN_KEY. Kept here to avoid creating a
// circular import (api.tsx ↔ AuthenticationService.tsx).
const TOKEN_KEY = "auth-token";

const API = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

API.interceptors.request.use(
  (config) => {
    if (config.headers.Authorization) {
      return config;
    }
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

API.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (shouldRedirectToLogin(error.config?.url, error.response?.status)) {
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default API;
